// extracted by mini-css-extract-plugin
module.exports = {"container":"Controls_container__2vZ0n","buttons":"Controls_buttons__YO3Jl","button":"Controls_button__1PwYl"};